module.exports = __webpack_public_path__ + "static/media/launch-page-bg-mobile.4492cdc4.jpg";